module.exports = __webpack_public_path__ + "static/img/menu2.a98a50c6.png";